import request from "@/http"

export interface Captcha {
  /**
   * eid
   */
  eid: string
  /**
   * encode by Base64
   */
  backImage: string
  /**
   * encode by Base64
   */
  slidingImage: string
  /**
   * y coordinate
   */
  y: number
}

/**
 * 获取验证码
 *
 * @export
 * @param {string} [path]
 * @returns {Promise<Captcha>}
 */
export async function getCaptcha(eid?: string) {
  try {
    const result = await request.get<Captcha>(`/v1/captcha`, {
      params: {
        eid,
      },
    })
    return result?.data
  } catch (error) {
    throw error
  }
}

/**
 * 校验验证码
 *
 * @export
 * @param {string} [id]
 * @param {number} [x]
 * @returns {Promise<boolean>}
 */
export const verityCaptcha = async function (eid: string, x: number): Promise<boolean> {
  try {
    const result = await request.get(`/v1/captcha/${eid}/verify`, {
      params: { x },
    })
    return result?.data
  } catch (error) {
    throw error
  }
}
